import React from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import moment from 'moment'
import groupBy from 'lodash/groupBy'
import sortBy from 'lodash/sortBy'
import get from 'lodash/get'
import { connect } from 'react-redux'

import { Collection, Group } from '../../components/details/collection'
import WorkOrderCardContainer from '../../containers/work-orders/work-order-card-container'
import { CollectionButton } from '../buttons'
import LiveWorkOrderChannel from './live-work-order-channel'
import LocationCard from '../locations/location-card'

class WorkOrders extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedGroupId: null
    }
  }

  selectGroup (groupId) {
    this.setState({ selectedGroupId: groupId })
  }

  deselectGroup () {
    this.setState({ selectedGroupId: null })
  }

  isSelectedGroup (groupId) {
    if (groupId == null) return false

    return this.state.selectedGroupId === groupId
  }

  workOrderCard (workOrder) {
    return (
      <WorkOrderCardContainer
        workOrderId={workOrder.id}
        key={workOrder.id}
        highlighted={this.isSelectedGroup(workOrder.groupId)}
        onMouseEnter={() => this.selectGroup(workOrder.groupId)}
        onMouseLeave={() => this.deselectGroup()}
      />
    )
  }

  issueBadge (issueCount, type) {
    if (!issueCount) return
    let badge

    switch (type){
      case 'needsWork':
        badge = <span className='badge needs-work right'>{`${issueCount}`}</span>
        break
      default:
        break
    }

    return badge
  }

  render () {
    let {
      backlogWorkOrders,
      regularWorkOrders,
      locations,
      children,
      hasNextPage,
      onLoadNextPage
    } = this.props

    var sortedRegularWorkOrders = {}
    let sortedKeys = []
    // const isAddingDisabled = this.props.userType === 'Supervisor'

    regularWorkOrders = sortBy(regularWorkOrders, 'startsAt')

    sortedRegularWorkOrders = groupBy(
      regularWorkOrders,
      (workOrder) => workOrder.startsAt.format('YYYY-MM-DD')
    )

    sortedKeys = Object.keys(sortedRegularWorkOrders).sort()

    // let collectionProps = (isAddingDisabled) ? {constraints: { width: '539px' }} : {constraints: { width: '595px' }, actionType: 'add', actionLink: '/work-orders/create'}
    let collectionProps = {constraints: { width: '595px' }, actionType: 'add', actionLink: '/work-orders/create'}
    return (
      <div className='work-orders-list'>
        {!!backlogWorkOrders.length &&
          <Collection constraints={{ width: '539px' }}>
            <Group title='Backlog'>
              {backlogWorkOrders.filter((workOrder) => workOrder.servicingsCounts && workOrder.servicingsCounts.total && workOrder.servicingsCounts.total > 0).map((workOrder) => this.workOrderCard(workOrder))}
            </Group>
          </Collection>
        }

        {!!locations.length &&
          <Collection constraints={{ width: '539px' }}>
            <Group title='Attention Required Needed'>
              {locations.map(location => (
                <LocationCard location={location} key={location.id} linkUrlBase={"location-issues"}>
                  {this.issueBadge(location.permanentIssueCount, 'permanent')}
                  {this.issueBadge(location.needsReviewIssueCount, 'needsReview')}
                  {this.issueBadge(location.needsWorkIssueCount, 'needsWork')}
                </LocationCard>
              ))}
            </Group>
          </Collection>
        }

        <Collection {...collectionProps}>
          {sortedKeys.length > 0 &&
            <ReactCSSTransitionGroup
              component='div'
              transitionName='workOrderGroup'
              transitionEnterTimeout={250}
              transitionLeaveTimeout={250}
            >
              {sortedKeys.map((group, i) => (
                <Group title={moment(group).format('MMMM Do, YYYY')} key={group}>
                  <ReactCSSTransitionGroup
                    component='div'
                    transitionName='workOrder'
                    transitionEnterTimeout={250}
                    transitionLeaveTimeout={250}
                  >
                    {sortedRegularWorkOrders[group].map((workOrder) => this.workOrderCard(workOrder))}
                  </ReactCSSTransitionGroup>
                </Group>
              ))}
            </ReactCSSTransitionGroup>
          }

          {hasNextPage &&
            <CollectionButton onClick={onLoadNextPage}>See more...</CollectionButton>}
        </Collection>
        {children}

        <LiveWorkOrderChannel />
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  const userType = get(state.auth, 'session.type')

  return {
    userType
  }
}

export default connect(mapStateToProps)(WorkOrders)



// WEBPACK FOOTER //
// ./src/components/work-orders/work-orders.js